/**
 * Servico de autenticacao - endpoints de perfil e senha
 */

import { api } from "./api";

export interface UpdateProfileData {
  nome?: string;
  email?: string;
}

export interface ChangePasswordData {
  senhaAtual: string;
  novaSenha: string;
}

export interface UserProfile {
  id: string;
  tenantId: string;
  nome: string;
  email: string;
  nivel: string;
  permissoes: string[];
  ativo: boolean;
  ultimoAcesso: string | null;
  createdAt: string;
}

export async function updateProfile(data: UpdateProfileData) {
  return api.put<UserProfile>("/auth/profile", data);
}

export async function changePassword(data: ChangePasswordData) {
  return api.put("/auth/change-password", data);
}
